// extracted by mini-css-extract-plugin
export default {"filter":"ProductFilter_filter__4Btt4","category":"ProductFilter_category__DG9Q4","brand":"ProductFilter_brand__03mcc","active":"ProductFilter_active__uei4L"};